import styled from 'styled-components';

type ExpertTableBlockProps = {
  text?: 'bold' | 'normal';
  center?: boolean;
  spaceBetween?: boolean;
};

export const ExpertsListContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1.8fr 1fr 1fr 1.5fr 1.3fr 1fr;
  gap: 2px;
  margin-top: 2px;
`;

export const ExpertTableBlock = styled.div<ExpertTableBlockProps>`
  width: 100%;
  height: 100%;

  background: #ecf1f7;
  color: #6287b3;
  font-size: 12px;
  font-weight: ${(props) => (props.text ? (props.text === 'bold' ? '500' : '400') : '400')};

  padding: 10px;

  display: flex;
  justify-content: ${(props) => (props.center ? 'center' : props.spaceBetween ? 'space-around' : 'flex-start')};
  align-items: center;
  gap: 10px;

  svg {
    height: 40px;
  }
`;
